<template>
    <div class="flex items-center justify-center space-x-2">
        <input
            v-for="(digit, index) in length"
            :key="index"
            ref="input"
            type="text"
            inputmode="numeric"
            autocomplete="one-time-code"
            maxlength="1"
            :value="otp[index]"
            :disabled="disabled"
            class="otp-input"
            @input="handleInput($event, index)"
            @keydown.backspace="handleBackspace($event, index)"
        />
    </div>
</template>


<script>
export default {
    name: "BaseInputOTP",
    props: {
        length: {
            type: Number,
            default: 6, // Jumlah digit OTP (default: 6)
        },
        modelValue: {
            type: String,
            required: true, // v-model binding dari parent
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            otp: Array(this.length).fill(""), // Array untuk menyimpan setiap digit OTP
        };
    },
    watch: {
        // Update modelValue dari parent ke komponen internal
        modelValue(newValue) {
            this.otp = newValue.split("").slice(0, this.length);
        },
        // Emit nilai OTP setiap kali ada perubahan
        otp: {
            handler(newOtp) {
                this.$emit("update:modelValue", newOtp.join("")); // Kirim kembali nilai gabungan
            },
            deep: true,
        },
    },
    methods: {
        handleInput(event, index) {
            const value = event.target.value;

            // Validasi input harus angka
            if (!/^\d$/.test(value)) {
                this.otp[index] = ""; // Kosongkan jika bukan angka
                return;
            }

            // Perbarui array otp pada index tertentu
            this.otp.splice(index, 1, value);

            // Pindah fokus ke input berikutnya jika ada
            if (index < this.length - 1) {
                this.$refs.input[index + 1]?.focus();
            }
        },
        handleBackspace(event, index) {
            if (!this.otp[index] && index > 0) {
                this.$refs.input[index - 1]?.focus(); // Fokus ke input sebelumnya
            }
        },
    },
};
</script>


<style scoped>
.otp-input {
    width: 3.75rem;
    height: 3.75rem;
    border: 1px solid #d1d5db;
    border-radius: 0.75rem;
    text-align: center;
    font-size: 1.75rem;
    font-weight: 600;
    color: #374151;
    line-height: 1;
    padding: 0 !important;
    margin: 0;
    background: #ffffff;
    font-family: inherit;
    caret-color: #111827;
}

.otp-input:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px #3b82f6;
}

.otp-input:disabled {
    background: #f3f4f6;
    color: #9ca3af;
    cursor: not-allowed;
}
</style>
